import { render } from "./createCompetition.vue?vue&type=template&id=4f49725e&scoped=true"
import script from "./createCompetition.vue?vue&type=script&lang=js"
export * from "./createCompetition.vue?vue&type=script&lang=js"

import "./createCompetition.vue?vue&type=style&index=0&id=4f49725e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f49725e"]])

export default __exports__